<template>
  <div class="md-content">
    <slot />
  </div>
</template>
<script lang="ts">
// import MdComponent from '../core/MdComponent'
import { defineComponent, h as createElement } from 'vue';
export default defineComponent({
  name: 'MdContent',
});
</script>
